import { CircularProgress, makeStyles, styled } from "@material-ui/core";
import { useIO } from "@type-r/react";
import { Button, CollapsableSection, Flex, asCurrency, div } from "lqx-react";
import * as React from "react";
import { useMemo } from "react";
import { BoundPolicyBuyer } from "../api/boundPolicy";
import { BoundPolicyBuyerInvoices } from "./bound-policy-buyer-invoices";
import { BoundPolicyBuyerSummary } from "./bound-policy-buyer-summary";

export const BoundPolicyBuyers = ({ title, buyers }: { title: string, buyers: BoundPolicyBuyer[] }) => {
    return (
        <BuyersCategory>
            <CollapsableSection title={title} notExpanded>
                {
                    buyers.map(buyer => <BuyerRow key={buyer.id} buyer={buyer} />)
                }
                {buyers.length <= 0 && <Flex row center>No Data Found</Flex>}
            </CollapsableSection>
        </BuyersCategory>
    );
};

export const BuyerRow = ({ buyer }: { buyer: BoundPolicyBuyer }) => {
    const classes = useBuyerRowClasses();

    const eligibleInvoicesCount = useMemo(() => buyer.invoices.filter(inv => inv.isEligible).length, [buyer['_changeToken']]);
    const nonEligibleInvoicesCount = useMemo(() => buyer.invoices.filter(inv => !inv.isEligible).length, [buyer['_changeToken']]);

    const linkBuyer = (e) => {
        buyer.$.isSelected.set(true);
        e.stopPropagation();
    }

    //TODO: load invoices on expand only, but nr of invoices is needed on the buyer
    const isReady = useIO(async () => buyer.invoices.length <= 0 && await buyer.invoices.fetch({ params: { buyerDuns: buyer.duns } }), [buyer.duns]);

    return (!isReady ? <LoadingLarge /> :
        <div key={buyer.id} className={classes.root}>
            <BuyerCollapsableSection>
                <CollapsableSection
                    qa-id="buyer"
                    title={
                        <>
                            <BuyerName >{buyer.name}</ BuyerName>
                            {buyer.invoices.length > 0 && <Button disabled={buyer.isSelected} onClick={linkBuyer}>{buyer.isSelected ? 'LINKED' : 'LINK'}</Button>}
                        </>
                    }
                    right={
                        <Flex row>
                            <ApprovedLimitValue>Approved Limit: {asCurrency(buyer.maxCreditLimit)}</ApprovedLimitValue>
                            <EligibleInvoicesValue>{eligibleInvoicesCount} Invoices Eligible</EligibleInvoicesValue>
                            <IneligibleInvoicesValue>{nonEligibleInvoicesCount} Invoices Ineligible</IneligibleInvoicesValue>
                        </Flex>
                    }>
                    <BoundPolicyBuyerSummary buyer={buyer} />
                    <Flex row><InvoicesLabel>Invoices</InvoicesLabel></Flex>
                    <BoundPolicyBuyerInvoices invoices={buyer.invoices} />
                </CollapsableSection>
            </BuyerCollapsableSection>

        </div >
    )
};

const useBuyerRowClasses = makeStyles({
    root: {
        backgroundColor: 'white'
    }
});

const BuyersCategory = div({
    '& .MuiAccordionSummary-content span': {
        textTransform: 'unset',
        color: '#4197d6'
    }
});

const BuyerName = styled('div')({
    color: '#4197d6',
});

/* for some reason the Loading from lqx-react is very small*/
const LoadingLarge = () => {
    return (
        <Flex center><CircularProgress disableShrink /></Flex>
    );
}

const BuyerCollapsableSection = div({
    '& .MuiAccordionSummary-content span': {
        textTransform: 'unset',
        color: '#4197d6'
    }
});

const InvoicesLabel = div({
    margin: '15px',
    fontFamily: 'Montserrat',
    fontStyle: 'normal',
    fontSize: '13px',
    color: '#758da6',
    fontWeight: 800
});

const ApprovedLimitValue = div({
    fontFamily: 'Montserrat',
    fontStyle: 'normal',
    fontSize: '13px',
    color: '#758da6',
    paddingRight: '20px'
});

const EligibleInvoicesValue = div({
    fontFamily: 'Montserrat',
    fontStyle: 'normal',
    fontSize: '13px',
    color: '#01c38d',
    paddingRight: '20px'
});
const IneligibleInvoicesValue = div({
    fontFamily: 'Montserrat',
    fontStyle: 'normal',
    fontSize: '13px',
    color: '#c32501',

});

